import * as R from "ramda";
import React, {Component} from "react";
import FlexView from "react-flexview";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import ReceivingUnitNOSInputs from "./receivingUnitNOSInputs";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import withFormGroup from "../../../../../modules/commons/withFormGroup";
import SimpleCheckBox from "../../../../../modules/SimpleCheckBox";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import SimpleAlert from "../../../../../modules/popup/SimpleAlert";
import Api from "../../../../../Services/Api";
import {tableConfig, tableDetailColumns} from "../config";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleInput from "../../../../../modules/SimpleInput";
import {mapToObjectDDL} from "../../../../common/mapper";
import {constructDataDetailUnitNOS, constructToQRReport, validateDataDetailUnitNOS} from "../util";
import {ACTIVITY_TYPE, HttpStatus} from "../../../../common/Constants";
import {contructQueryParam, fetchDataAsync} from "../../../../../Services/Utils";
import ReceivingUnitNOSPreviewQR from "./receivingUnitNOSPreviewQR";
import {v4 as uuidv4} from "uuid";

class ReceivingUnitNOSDetail extends Component {
    tableColumnCorrection = [
        {
            name: "id",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    return <>{tableMeta.rowIndex + 1}</>;
                },
            },
        },
        {
            name: "kodeVarian",
            label: "Kode Varian*",
            options: {
                customBodyRender: (value, tableMeta) => {
                    const isSaved = tableMeta.rowData[tableMeta.rowData.length - 1];
                    return (
                        <SimpleDDL
                            id={`select_options_kode_varian_${tableMeta.rowIndex}`}
                            box="search"
                            name="kodeVarian"
                            containerclassname="margin-bottom-none"
                            readOnly={isSaved}
                            menuPosition="fixed"
                            options={this.state.dataVariant.map(
                                item => mapToObjectDDL(
                                    item.kodeVariant,
                                    item.kodeVariant
                                ))}
                            value={value}
                            onChange={(value) =>
                                this.handleSelectCodeVariant(tableMeta.rowIndex, "kodeVarian", value)
                            }
                        />
                    );
                },
                setCellProps: () => ({
                    style: {minWidth: "250px"},
                }),
            },
        },
        {
            name: "namaVarian",
            label: "Nama Varian",
            options: {
                customBodyRender: (value) => {
                    return value ? value : "-";
                },
                setCellProps: () => ({
                    style: {minWidth: "150px"},
                }),
            },
        },
        {
            name: "frameNumber",
            label: "NoKa*",
            options: {
                customBodyRender: (val, tableMeta) => {
                    const isSaved = tableMeta.rowData[tableMeta.rowData.length - 1];
                    return (
                        <SimpleInput
                            id="input_text_frame_number"
                            name="frameNumber"
                            readOnly={isSaved}
                            containerclassname="margin-bottom-none"
                            value={val}
                            onChange={({target}) =>
                                this.handleValueChange(tableMeta.rowIndex, target.name, target.value)
                            }
                        />
                    );
                },
                setCellProps: () => ({
                    style: {minWidth: "150px"},
                }),
            },
        },
        {
            name: "engineNumber",
            label: "NoSin*",
            options: {
                customBodyRender: (val, tableMeta) => {
                    const isSaved = tableMeta.rowData[tableMeta.rowData.length - 1];
                    return (
                        <SimpleInput
                            id="input_text_frame_number"
                            name="engineNumber"
                            readOnly={isSaved}
                            containerclassname="margin-bottom-none"
                            value={val}
                            onChange={({target}) =>
                                this.handleValueChange(tableMeta.rowIndex, target.name, target.value)
                            }
                        />
                    );
                },
                setCellProps: () => ({
                    style: {minWidth: "150px"},
                }),
            },
        },
        {
            name: "kodeWarna",
            label: "Kode Warna*",
            options: {
                customBodyRender: (value, tableMeta) => {
                    const isSaved = tableMeta.rowData[tableMeta.rowData.length - 1];
                    return (
                        <SimpleDDL
                            id={`select_options_kode_warna_${tableMeta.rowIndex}`}
                            box="search"
                            name="kodewarna"
                            readOnly={isSaved}
                            containerclassname="margin-bottom-none"
                            menuPosition="fixed"
                            options={!R.isNil(this.state.dataWarna) && !R.isEmpty(this.state.dataWarna)
                                ? this.state.dataWarna[tableMeta.rowIndex]?.map(
                                    item => mapToObjectDDL(
                                        item.kodeWarna,
                                        item.id
                                    )) : []
                            }
                            value={value}
                            onChange={(value) =>
                                this.handleSelectColorCode(tableMeta.rowIndex, "kodeWarna", value)
                            }
                        />
                    );
                },
                setCellProps: () => ({
                    style: {minWidth: "250px"},
                }),
            },
        },
        {
            name: "namaWarnaPabrik",
            label: "Warna",
            options: {
                customBodyRender: (value) => {
                    return value ? value : "-";
                },
                setCellProps: () => ({
                    style: {minWidth: "100px"},
                }),
            },
        },
        {
            name: "rfsStatus",
            label: "RFS",
            options: {
                customBodyRender: (val, tableMeta) => {
                    const isSaved = tableMeta.rowData[tableMeta.rowData.length - 1];
                    return (
                        <SimpleCheckBox
                            id="input_checkbox_rfs"
                            type="checkbox"
                            name="rfsStatus"
                            disabled={isSaved}
                            checked={!!R.equals(val, "RFS")}
                            onChange={({target}) =>
                                this.handleValueChange(tableMeta.rowIndex, target.name, target.checked)
                            }
                        />
                    );
                },
                sort: false,
            },
        },
        {
            name: "yearManufactured",
            label: "Thn. Prod",
            options: {
                customBodyRender: (val, tableMeta) => {
                    const isSaved = tableMeta.rowData[tableMeta.rowData.length - 1];
                    return (
                        <SimpleInput
                            id="input_text_thn_prod"
                            box="onlyNumber"
                            name="yearManufactured"
                            readOnly={isSaved}
                            containerclassname="margin-bottom-none"
                            value={val}
                            onChange={({target}) =>
                                this.handleValueChange(tableMeta.rowIndex, target.name, target.value)
                            }
                        />
                    );
                },
                setCellProps: () => ({
                    style: {minWidth: "100px"},
                }),
            },
        },
        {
            name: "kodeLocation",
            label: "[*] All Locator",
            options: {
                customHeadRender: (props) => {
                    return (
                        <th key="locatorKey" className="custom-locator">
                            <FlexView vAlignContent="center" style={{gap: "10px"}}>
                                <p>{props.label}</p>
                                <SimpleDDL
                                    id="select_options_header_locator"
                                    containerclassname="margin-bottom-none width width-250px"
                                    box="search"
                                    styles={{
                                        menu: (provided) => ({
                                            ...provided,
                                            position: "relative",
                                            fontFamily: "FontFirst2, Helvetica Neue, Helvetica, Arial, sans-serif",
                                        }),
                                    }}
                                    isClearable={true}
                                    options={this.state.dataLocator ? this.state.dataLocator.map(
                                        item => mapToObjectDDL(
                                            item.nameLocation,
                                            item.kodeLocation
                                        )) : []}
                                    onChange={this.handleMultipleLocatorChange}
                                />
                            </FlexView>
                        </th>
                    );
                },
                customBodyRender: (val, tableMeta) => {
                    const isSaved = tableMeta.rowData[tableMeta.rowData.length - 1];
                    return (
                        <SimpleDDL
                            id={`select_options_locator_${tableMeta.rowIndex}`}
                            containerclassname="margin-bottom-none width width-250px"
                            box="search"
                            value={val}
                            menuPosition="fixed"
                            onChange={(value) =>
                                this.handleSingleLocatorChange(tableMeta.rowIndex, value)
                            }
                            options={this.state.dataLocator ? this.state.dataLocator.map(
                                item => mapToObjectDDL(
                                    item.nameLocation,
                                    item.kodeLocation
                                )) : []}
                            readOnly={isSaved}
                            isClearable={true}
                        />
                    );
                },
                sort: false,
            },
        },
        {
            name: "saved",
            label: "Aksi",
            options: {
                customBodyRender: (val, {rowIndex}) => (
                    <FlexView style={{gap: "10px"}}>
                        {this.state.dataTable[rowIndex].checkEdit ?
                            <>
                                {
                                    !val ?
                                        <SimpleButton
                                            className={"btn background-red"}
                                            styles={{width: "unset", marginLeft: "0px"}}
                                            onClick={() => this.handleSaveRow(rowIndex)}
                                            icon={<i className="fa fa-save"/>}
                                        />
                                        :
                                        <SimpleButton
                                            className={"btn background-red"}
                                            styles={{width: "unset", marginLeft: "0px"}}
                                            onClick={() => this.handleEditRow(rowIndex)}
                                            icon={<i className="fa fa-lw fa-pencil-alt"/>}
                                        />
                                }
                                <SimpleButton
                                    className={"btn background-red"}
                                    styles={{width: "unset", marginLeft: "0px"}}
                                    onClick={() => this.handleDeleteRow(rowIndex)}
                                    icon={<i className="fa fa-trash"></i>}
                                />
                            </> : <></>}
                    </FlexView>
                ),
                sort: false,
            },
        },
    ];

    constructor(props) {
        super(props);
        this.initialData = {
            kodeVarian: null,
            frameNumber: null,
            engineNumber: null,
            kodeWarna: null,
            rfsStatus: false,
            yearManufactured: null,
            locatorDTO: null,
            variantDTO: null,
            warnaDTO: null,
            numberOfPrint: null,
            saved: false,
            checkEdit: true
        };
        this.state = {
            warningModalVisible: false,
            warningMessage: null,
            deleteModalVisible: false,
            previewQrVisible: false,
            PDF: null,
            activityRead: true,
            tableConfig: tableDetailColumns.detail,
            tableOptions: tableConfig.nosOptionDetail(this.handleOnRowSelected, this.handleChangePage, this.handleRowsPerPage),
            dataDetailRollBack: [],
            dataDetailSaved: [],
            dataTable: [],
            dataVariant: [],
            dataWarna: [],
            dataSupplier: [],
            dataSupplierExpedition: [],
            dataLocator: [],
            savedDataHeader: null,
            dataDetail: null,
            selectedDataQR: [],
            selectedRow: [],
            isCanDelete: true,
            popupApproval: {
                data: [],
                visible: false,
                isConfirmation: false,
                barcodeNeedApproval: []
            },
            pagination: {
                page: 1,
                limit: 5,
                totalData: 0,
            },
        };
    }

    componentDidMount = async () => {
        this.handleTriggerLoading();
        this.fetchDataLocator();
        this.fetchDataSupplierExpedition();
        this.props.setValue("kodeCabang", this.props.selectedCabang);

        if (R.equals(this.props.activityType, ACTIVITY_TYPE.UPDATE)) {
            let res = await this.fetchDataDetail(contructQueryParam({
                spbmNo: this.props.controls.spbmNo.value,
            }));

            if (res.ok) {
                this.props.setValue("invoiceNo", res.data.data?.invoiceNo);
                this.props.setValue("noPolisi", res.data.data?.noPolisi);
                this.props.setValue("poId", res.data.data?.poId);
                this.props.setValue("description", res.data.data?.description);
                this.props.setValue("manual", res.data.data?.manual);
                let supplier = res.data.data?.supplierDTO;
                this.props.setValue(
                    "kodeSupplier",
                    supplier ? mapToObjectDDL(supplier.supplierName, supplier.supplierCode) : null
                );
                let supplierExp = res.data.data?.supplierExpeditionDTO;
                this.props.setValue(
                    "kodeSupplierExpedition",
                    supplierExp ? {
                        value: supplierExp.supplierCode,
                        label: supplierExp.supplierCode,
                        name: supplierExp.supplierName
                    } : null
                );
                let dataDetail = res.data.data?.details.map((item) => {
                    return {
                        ...item,
                        kodeVarian: mapToObjectDDL(
                            item.variantDTO?.kodeVariant,
                            item.variantDTO?.kodeVariant,
                        ),
                        namaVarian: item.variantDTO?.namaVariant,
                        kodeWarna: mapToObjectDDL(
                            item.warnaDTO?.kodeWarna,
                            item.warnaDTO?.id,
                        ),
                        namaWarnaPabrik: item.warnaDTO?.namaWarnaPabrik,
                        kodeLocation: item.locatorDTO ? mapToObjectDDL(
                            item.locatorDTO?.nameLocation,
                            item.locatorDTO?.kodeLocation,
                        ) : null,
                        saved: true,
                        id: uuidv4(),
                        encryptedBarcode: item.encryptedBarcode
                    }
                });
                this.props.setValue("dataTable", dataDetail);
                this.setState((prevValue) => ({
                    ...prevValue,
                    dataTable: dataDetail,
                    dataDetailSaved: dataDetail,
                    dataDetailRollBack: dataDetail,
                    isCanDelete: res.data.data?.checkDelete,
                    pagination:{
                        ...prevValue.pagination,
                        totalData: dataDetail?.length
                    }
                }));
            }
        }
        if(this.props.isEditable){
            this.handleCorrection("correction")
        }

        this.handleTriggerLoading();
    }

    componentDidUpdate = async (prevProps, prevState) => {
        if (prevState.activityRead !== this.state.activityRead) {
            this.handleTriggerLoading();
            if (R.isEmpty(this.state.dataVariant)) {
                await this.fetchDataVariant();
            }

            this.setState((prevValue) => ({
                ...prevValue,
                tableConfig: prevValue.activityRead
                    ? tableDetailColumns.detail
                    : this.tableColumnCorrection,
                tableOptions: prevValue.activityRead
                    ? tableConfig.nosOptionDetail(this.handleOnRowSelected, this.handleChangePage, this.handleRowsPerPage)
                    : tableConfig.nosOptionCorrection(this.handleChangePage, this.handleRowsPerPage),
            }));
            this.handleTriggerLoading();
        }
    }

    handleCorrection = async (action) => {
        if (R.equals(action, "cancel_correction")) {
            if (!R.isNil(this.state.savedDataHeader)) {
                this.props.setValue("spbmDate", this.state.savedDataHeader.spbmDate.value);
                this.props.setValue("noPolisi", this.state.savedDataHeader.noPolisi.value);
                this.props.setValue("kodeSupplierExpedition", this.state.savedDataHeader.kodeSupplierExpedition.value);
            }

            this.setState((prevState) => ({
                ...prevState,
                activityRead: !prevState.activityRead,
                dataTable: prevState.dataDetailRollBack,
                dataDetailSaved: [],
            }))

        } else {
            this.setState((prevValue) => ({
                ...prevValue,
                activityRead: !prevValue.activityRead,
                dataTable: [
                    ...prevValue.dataTable.filter(data => R.equals(data.saved, true)),
                ],
                dataDetailSaved: [
                    ...prevValue.dataTable.filter(data => R.equals(data.saved, true)),
                ],
            }));
        }
    }

    handlePopupAlertVisibility = (data, barcodeNeedApproval) => {
        this.setState(prev=>({
            popupApproval: {
              data: data || [],
              visible: !prev.popupApproval.visible,
              isConfirmation: Boolean(barcodeNeedApproval),
              barcodeNeedApproval: barcodeNeedApproval  || []
            },
        }));
    }

    validateQRCodePrintApproval = async () => {
        const userId = localStorage.getItem("userId");
        const { selectedDataQR } = this.state;
        const { controls, selectedCabang } = this.props;    
        const payload = {
          trxId: controls.spbmNo.value,
          kodeCabang: selectedCabang?.value,
          idUserPemohon: userId,
          module: "RECEIVING_UNIT",
          listBarcode: selectedDataQR?.map(item => item.engineNumber),
        };
        const response = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_TRANSACTION").checkPrintQRKSUApproval,
            menuName: "Receiving Unit - KSU",
            setError: this.props.setError,
            args: payload
        })
        console.log(response,'response')
        if (response.ok && response.data.status === HttpStatus.SUCCESS) {
          const { listBarcodeToPrint, listBarcodeNeedApproval, listIdRequest } = response.data.data;    
          if (listBarcodeToPrint) {
            await this.fetchGenerateQRCode();
          } else {
            this.handlePopupAlertVisibility(listBarcodeNeedApproval || listIdRequest, listBarcodeNeedApproval)
          }
        }else{
            throw new Error(response.data.message)
        }
    };

    createApprovalQRPrint = async () =>{
        const { controls, selectedCabang } = this.props;
        const {popupApproval} = this.state;
        const userId = localStorage.getItem("userId");

        this.handleTriggerLoading()

        const payload = {
            trxId: controls.spbmNo.value,
            kodeCabang: selectedCabang?.value,
            idUserPemohon: userId,
            module: "RECEIVING_UNIT",
            listBarcode: popupApproval?.barcodeNeedApproval || [],
        };
        const res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_TRANSACTION").createApprovalPrint,
            menuName: "Receiving Unit - KSU",
            setError: this.props.setError,
            args: payload,
        })
        this.handleTriggerLoading()
        if(res.ok && res.data.status === HttpStatus.SUCCESS){
            this.handlePreviewQrVisibility("close")
            this.handlePopupAlertVisibility()
        }
    }

    handlePreviewQrVisibility = async (action) => {
        this.handleTriggerLoading();
        if (R.equals(action, "generate")) {
            if(this.state.selectedDataQR.length === 0){
                this.handleTriggerLoading();
                return this.handleWarningModalVisibility("Data belum di ceklis, harap pilih data terlebih dahulu untuk dicetak.")
            }
            await this.validateQRCodePrintApproval();
        }

        if (R.equals(action, "close")) {
            await this.componentDidMount();
            this.setState((prevValue) => ({
                ...prevValue,
                previewQrVisible: false,
            }));
        }
        this.handleTriggerLoading();
    };

    handleModalDeleteVisibility = () => {
        this.setState((prevState) => ({
            ...prevState,
            deleteModalVisible: !prevState.deleteModalVisible,
        }));
    };

    handleWarningModalVisibility = (text) => {
        this.setState((prevState) => ({
            ...prevState,
            warningMessage: text,
            warningModalVisible: !prevState.warningModalVisible,
        }))
    }

    handleClear = () => {
        this.setState((prevState) => ({
            ...prevState,
            dataTable: prevState.dataTable.filter(item => item.saved),
            savedDataHeader: {
                ...prevState.savedDataHeader,
                spbmDate: this.props.controls.spbmDate,
                noPolisi: this.props.controls.noPolisi,
                kodeSupplierExpedition: this.props.controls.kodeSupplierExpedition,
            }
        }));

        this.props.setValue("spbmDate", new Date());
        this.props.setValue("noPolisi", null);
        this.props.setValue("kodeSupplierExpedition", {});
    }

    handleStateChange = (callback) => {
        this.setState(callback);
    };

    handleValueChange = (index, name, value) => {
        let valueParsed;
        if (R.equals(name, "rfsStatus")) {
            if (R.equals(value, true)) {
                valueParsed = "RFS";
            } else {
                valueParsed = "NRFS";
            }
        } else {
            valueParsed = value;
        }

        this.setState((prevValue) => {
            const newState = [...prevValue.dataTable];
            newState[index] = {
                ...newState[index],
                [name]: valueParsed
            };

            return {
                ...prevValue,
                dataTable: newState,
            };
        });
    };

    handleSingleLocatorChange = (index, value) => {
        this.setState((prevValue) => {
            const newState = [...prevValue.dataTable];
            newState[index] = {
                ...newState[index],
                kodeLocation: value,
            };
            return {
                ...prevValue,
                dataTable: newState,
            };
        });
    };

    handleMultipleLocatorChange = (value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            dataTable: prevValue.dataTable.map((data) => ({
                ...data,
                kodeLocation: !data.saved ? value : data.kodeLocation,
            })),
        }));
    };

    handleAddRow = async () => {
        try {
            const newUnit = {
                ...this.initialData,
                id: uuidv4()
            };

            this.setState((prevValue) => ({
                ...prevValue,
                dataTable: [...prevValue.dataTable, newUnit],
                dataDetailSaved: [...prevValue.dataDetailSaved, newUnit],
            }));
        } catch (error) {
            console.log("errors: ", error);
        }
    };

    handleSaveRow = async (index) => {
        this.handleTriggerLoading();
        const {dataTable} = this.state;
        const {engineNumber, id} = dataTable[index];
        const filteredData = dataTable.filter((_, i) => i !== index);
        const isDuplicate = filteredData.some((row) => row.engineNumber === engineNumber);

        let isValidUnit = true;
        const selectedRow = this.state.selectedRow.find(row => row.id === id);
        if (selectedRow?.engineNumber !== engineNumber) {
            const res = await this.fetchCheckValidUnit(
                contructQueryParam({engineNumber: engineNumber})
            )
            isValidUnit = res.ok && res.data.data.valid;
        }


        if (!isDuplicate && isValidUnit) {
            this.setState((prevValue) => {
                const newState = [...prevValue.dataTable];
                newState[index] = {
                    ...newState[index],
                    rfsStatus: newState[index].rfsStatus === 'RFS' ? "RFS" : "NRFS",
                    spbmNo: this.props.controls.spbmNo.value,
                    kodeCabang: this.props.selectedCabang,
                    yearManufactured: newState[index].yearManufactured
                        ? Number(newState[index].yearManufactured)
                        : null,
                    saved: !newState[index].saved,
                };

                return {
                    ...prevValue,
                    dataTable: newState,
                    dataDetailSaved: newState,
                    selectedRow: [...prevValue.selectedRow.filter((item, _) => item.id !== id)],
                };
            });
        } else {
            this.handleWarningModalVisibility("Unit ini sudah terdaftar. Silahkan tambahkan unit lainnya");
        }

        this.handleTriggerLoading();
    };

    handleEditRow = async (index) => {
        this.setState((prevValue) => {
            const newState = [...prevValue.dataTable];
            newState[index] = {
                ...newState[index],
                spbmNo: this.props.controls.spbmNo.value,
                kodeCabang: this.props.selectedCabang,
                yearManufactured: newState[index].yearManufactured
                    ? Number(newState[index].yearManufactured)
                    : null,
                saved: !newState[index].saved,
            };

            return {
                ...prevValue,
                dataTable: newState,
                selectedRow: [...prevValue.selectedRow, newState[index]],
            };
        });

        const kodeVariant = this.state.dataTable[index].kodeVarian?.value;
        await this.fetchDataWarna({paramFilters: {kodeVariant: kodeVariant}}, index);
    };

    handleDeleteRow = (index) => {
        const {id} = this.state.dataTable[index];
        this.setState((prevValue) => ({
            ...prevValue,
            dataTable: [...prevValue.dataTable.filter((_, idx) => idx !== index)],
            dataDetailSaved: [...prevValue.dataDetailSaved.filter((_, idx) => idx !== index)],
            selectedRow: [...prevValue.selectedRow.filter((item, _) => item.id !== id)],
        }));
    };

    handleSelectCodeVariant = async (index, name, value) => {
        if (!R.isEmpty(this.state.dataVariant)) {
            let variant = this.state.dataVariant.find(item => item.kodeVariant === value.value);
            this.setState((prevValue) => {
                const newState = [...prevValue.dataTable];
                newState[index] = {
                    ...newState[index],
                    [name]: value,
                    namaVarian: variant.namaVariant,
                    frameNumber: variant.digitAwalNoka,
                    engineNumber: variant.digitAwalNosin,
                    kodeWarna: null,
                    namaWarnaPabrik: null,
                };

                return {
                    ...prevValue,
                    dataTable: newState,
                };
            });

            await this.fetchDataWarna({paramFilters: {kodeVariant: variant.kodeVariant}}, index);
        }
    };

    handleSelectColorCode = (index, name, value) => {
        if (!R.isEmpty(this.state.dataWarna[index])) {
            let warna = this.state.dataWarna[index].find(item => item.id === value.value);
            this.setState((prevValue) => {
                const newState = [...prevValue.dataTable];
                newState[index] = {
                    ...newState[index],
                    [name]: value,
                    namaWarnaPabrik: warna.namaWarnaPabrik,
                };

                return {
                    ...prevValue,
                    dataTable: newState,
                };
            });
        }
    };

    handleOnRowSelected = (listIndex) => {
        const selectedData = listIndex.map(index => this.state.dataTable[index]);
        this.setState((prevState) => ({
            ...prevState,
            selectedDataQR: selectedData,
        }))
    }

    handleSubmitDelete = async () => {
        this.props.onDelete();
        this.handleModalDeleteVisibility();
    }

    handleSubmit = () => {
        if (!this.props.validate() || !validateDataDetailUnitNOS(this.state.dataDetailSaved)) {
            this.handleWarningModalVisibility("Ada field data yang perlu diisi atau tidak sesuai kriteria isian.");
        } else {
            let details = constructDataDetailUnitNOS(this.state.dataDetailSaved, this.props.controls);
            this.props.onSubmit("update", this.props.controls, details);
        }
    }

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    fetchDataDetail = async (requestParam) => {
        try {
            return await Api.create("NAGAMAS_TRANSACTION").getDetailReceivingUnitNOS(requestParam);
        } catch (error) {
            console.log("errors: ", error);
        }
    };

    fetchDataVariant = async () => {
        try {
            let response = await Api.create("NAGAMAS_MASTER_DATA").getAllVariant();
            if (response.ok) {
                this.setState((prevState) => ({
                    ...prevState,
                    dataVariant: response.data.data
                }));
            }
        } catch (error) {
            console.log("errors: ", error);
        }
    };

    fetchDataWarna = async (body, index) => {
        try {
            let response = await Api.create("NAGAMAS_MASTER_DATA").getAllWarnaByParam(body);
            if (response.ok) {
                this.setState((prevState) => ({
                    ...prevState,
                    dataWarna: {...prevState.dataWarna, [index]: response.data.data},
                }));
            }
        } catch (error) {
            console.log("errors: ", error);
        }
    }

    fetchDataLocator = async () => {
        try {
            let res = await Api.create("NAGAMAS_MASTER_DATA").getAllMasterLocationPagingByParam({
                paramFilters: {kodeCabang: this.props.selectedCabang?.value},
                page: null,
                limit: null
            })

            if (res.ok) {
                this.setState((prevState) => ({
                    ...prevState,
                    dataLocator: res.data.data
                }));
            }

        } catch (error) {
            console.log("errors: ", error);
        }
    }

    fetchDataSupplierExpedition = async () => {
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllSupplierExpedition,
            menuName: "Receiving Unit - NOS",
            setError: this.props.setError,
            args: contructQueryParam({kodeCabang: this.props.selectedCabang.value}),
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.setState((prevState) => ({
                ...prevState,
                dataSupplierExpedition: res.data.data,
            }));
        }
    }

    fetchGenerateQRCode = async () => {
        try {
            let reqBody = constructToQRReport(this.state.selectedDataQR, this.props.controls)
            let res = await Api.create("NAGAMAS_REPORT").generateQRReceivingUnitNOS(reqBody)
            if (res.ok) {
                if (reqBody.length > 0) {
                    await this.fetchUpdateNumberOfPrintQRCode();
                    
                this.setState((prevState) => ({
                    ...prevState,
                    previewQrVisible: true,
                    PDF: URL.createObjectURL(res.data)
                }));
                }
            }
        } catch (error) {
            console.log("errors: ", error);
        }
    }

    fetchUpdateNumberOfPrintQRCode = async () => {
        try {
            let reqBody = this.state.selectedDataQR.map(item => item.engineNumber);
            await Api.create("NAGAMAS_TRANSACTION").updateNumberOfPrintQRCodeUnitNOS(reqBody)
        } catch (error) {
            console.log("errors: ", error);
        }
    }

    fetchCheckValidUnit = async (body) => {
        try {
            return await Api.create("NAGAMAS_TRANSACTION").checkingValidUnitNOS(body)
        } catch (error) {
            console.log("errors: ", error);
        }
    }

    renderAlertApproval = () =>{
            const { popupApproval } = this.state;
            const isConfirmation = popupApproval.isConfirmation;
            const title = isConfirmation ? "Konfirmasi" : "Informasi";
            const subTitle = isConfirmation ? "Cetak ulang QR dengan no QR:" : "Pengajuan tidak dapat dilakukan sebelum pengajuan dengan No. Request: " 
            const desc = isConfirmation ? "Apakah anda yakin?" : "dilakukan keputusan APPROVE/REJECT"
            return (
                <SimpleAlert
                  title={title}
                  visible={popupApproval.visible}
                  onClickClose={() => this.handlePopupAlertVisibility()}
                  content={
                    <div style={{textAlign:'left'}}>
                        <p style={{marginBottom:'10px'}}>{subTitle}</p>
                        <FlexView style={{gap:'10px', maxHeight: "200px", overflowY: "auto"}}>
                             <ul
                              style={{
                                listStyleType: 'circle',
                                paddingLeft: '20px'
                              }}
                            >
                                {popupApproval.data.map(item=> <li key={item}>{item}</li>)}
                            </ul>
                        </FlexView>
                        <p style={{marginTop:'10px'}}>{desc}</p>
                    </div>
                  }
                  additionalButtons={
                    isConfirmation ? (
                      <FlexView vAlignContent="center" style={{ gap: "10px" }}>
                        <SimpleButton onClick={() => this.handlePopupAlertVisibility()}>
                          TIDAK
                        </SimpleButton>
                        <SimpleButton onClick={this.createApprovalQRPrint}>
                          YA
                        </SimpleButton>
                      </FlexView>
                    ) : (
                      <SimpleButton onClick={() => this.handlePopupAlertVisibility()}>
                        OK
                      </SimpleButton>
                    )
                  }
                />
            )
        }

    handleChangePage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: tableState.page + 1,
            }
        }));
    };

    handleRowsPerPage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: 1,
                limit: tableState.rowsPerPage,
            }
        }));
    };

    render() {
        return (
            <>
                <SimpleModal
                    title="Detail Penerimaan Unit - NOS"
                    visible={this.props.visible}
                    onClickClose={() => this.props.onClickClose()}
                    content={
                        <ModalContainer>
                            <ReceivingUnitNOSInputs
                                {...this.props}
                                activityRead={this.state.activityRead}
                                dataSupplier={this.state.dataSupplier}
                                dataSupplierExpedition={this.state.dataSupplierExpedition}
                            />

                            {
                                this.state.activityRead ?
                                    <FlexView vAlignContent="center" style={{justifyContent: "space-between"}}>
                                        <h3 className="margin-bottom-10px">Detail Penerimaan :</h3>
                                        <h4 className="margin-bottom-10px">Jumlah
                                            Data: {this.state.dataTable?.length}</h4>
                                    </FlexView>
                                    :
                                    <FlexView vAlignContent="center" className="margin-bottom-10px">
                                        <h4 className="margin-right-10px">UNIT MOTOR</h4>
                                        <SimpleButton
                                            className={"btn btn-plus background-red margin-left-10px"}
                                            onClick={this.handleAddRow}
                                            icon={<i className="fa fa-plus margin-right-10px"></i>}
                                            text={"Tambah Unit"}
                                        />
                                    </FlexView>
                            }
                            <SimpleDataTable
                                key={`${this.state.pagination.totalData}-${this.state.pagination.page}`}
                                data={this.state.dataTable}
                                columns={this.state.tableConfig}
                                options={this.state.tableOptions}
                                toCount={this.state.pagination.totalData}
                                rowsPerPage={this.state.pagination.limit}
                                page={this.state.pagination.page - 1}
                            />
                            <br/>
                            <FlexView style={{justifyContent: "space-between"}}>
                                {!this.props.isEditable && (
                                  <SimpleButton
                                    text={"Print QR"}
                                    className="margin-left-none margin-top-10px"
                                    onClick={() => this.handlePreviewQrVisibility("generate")
                                    }
                                  />
                                )}
                                {
                                    this.state.activityRead ?
                                        <FlexView vAlignContent="center">
                                            {/* {this.props.userAccess && this.props.userAccess.updateAccess && (
                                                <SimpleButton
                                                    text="Koreksi"
                                                    onClick={() => this.handleCorrection("correction")}
                                                />
                                            )} */}

                                            {this.props.userAccess && this.props.userAccess.deleteAccess && this.state.isCanDelete && (
                                                <SimpleButton
                                                    type="button"
                                                    text="Hapus"
                                                    onClick={this.handleModalDeleteVisibility}
                                                />
                                            )}

                                            <SimpleButton
                                                type="button"
                                                text="Keluar"
                                                onClick={() => this.props.onClickClose()}
                                            />
                                        </FlexView>
                                        :
                                        <FlexView vAlignContent="center">
                                            <SimpleButton
                                                type="button"
                                                text="Clear"
                                                onClick={this.handleClear}
                                            />
                                            <SimpleButton
                                                type="button"
                                                text="Simpan"
                                                onClick={this.handleSubmit}
                                            />
                                            <SimpleButton
                                                type="button"
                                                text="Batal"
                                                onClick={() => this.handleCorrection("cancel_correction")}
                                            />
                                        </FlexView>
                                }

                            </FlexView>

                            {this.state.deleteModalVisible && (
                                <SimpleAlert
                                    title={"Warning!"}
                                    content={"Apakah Anda Yakin?"}
                                    visible={this.state.deleteModalVisible}
                                    onClickClose={this.handleModalDeleteVisibility}
                                    onSubmit={this.handleSubmitDelete}
                                    additionalButtons={
                                        <FlexView style={{gap: "15px"}}>
                                            <SimpleButton
                                                className="margin-left-none"
                                                type="button"
                                                text="Batal"
                                                onClick={() => this.handleModalDeleteVisibility()}
                                            />
                                            <SimpleButton
                                                secondary
                                                className="margin-left-none"
                                                type="button"
                                                text="Iya"
                                                onClick={() => this.handleSubmitDelete()}
                                            />
                                        </FlexView>
                                    }
                                />
                            )}

                            {this.state.warningModalVisible && (
                                <SimpleAlert
                                    title={"Information"}
                                    content={
                                        <div>
                                            <p>
                                                {this.state.warningMessage}
                                                <br/>
                                                Mohon periksa kembali.
                                            </p>
                                        </div>
                                    }
                                    visible={this.state.warningModalVisible}
                                    onClickClose={this.handleWarningModalVisibility}
                                    additionalButtons={
                                        <SimpleButton
                                            type="button"
                                            text="OK"
                                            onClick={() => this.handleWarningModalVisibility()}
                                        />
                                    }
                                />
                            )}

                            <SimpleLoadingOverlay active={this.state.loading}/>
                        </ModalContainer>
                    }
                />

                {this.state.previewQrVisible && (
                    <ReceivingUnitNOSPreviewQR
                        PDF={this.state.PDF}
                        visible={this.state.previewQrVisible}
                        onPreviewQr={() => {
                            this.handlePreviewQrVisibility("close")
                            this.setState({ selectedDataQR: []})
                        }}
                        onStateChange={this.handleStateChange}
                    />
                )}
                {this.renderAlertApproval()}
            </>
        );
    }
}

export default withFormGroup(ReceivingUnitNOSDetail);
